module.exports = __webpack_public_path__ + "media/main_cards/carrier_growth-6f07514c.svg";